import React, {useState, useCallback} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, Input } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image, View, TouchableOpacity } from 'react-native';
import { TopBar } from '../support-screen/topBar.js'
import * as RootNavigation from '../../../root.navigation.js';
import trackerApi from '../../api/tracker';
import { showMessage, hideMessage } from "react-native-flash-message";
import {AutocompleteSimpleUsageShowcase} from '../Doing-tasks-screen/autocomplete.js'


const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;

function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
    // A function that increment 👆🏻 the previous state like here
    // is better than directly setting `setValue(value + 1)`
}

const PlusIcon = (props) => (
  <Icon {...props} name='plus-square-outline' />
);
const InfoIcon = (props) => (
  <Icon {...props} name='info-outline' />
);
export const Prices = () => {
  const [selectedTariff, setSelectedTariff] = useState()
  const [actions, setActions] = useState([])
  const [qty, setQty] = useState(1)
  const [totalAmount, setTotalAmount] = useState(0)
  const getTariffs = async() =>{
    const response = await trackerApi.post('/client/tariff', {model});
    if(response.data.status){
      setServices(response.data.allData)
    }
    else {
      showMessage({
        message: `خطای دیتابیس`,
        type: "danger",
        icon: AlertIcon
      });
    }
  }
  React.useEffect(()=>{
    getTariffs()
  },[])

  const clickAdd = async()=>{
    const mw = actions;
    await mw.push({title:selectedTariff.service_name, price:selectedTariff.service_cost, tariff_id:selectedTariff.id, qty})
    setActions(mw)
    // console.log(actions);
    const test = selectedTariff
    setSelectedTariff([])
    setSelectedTariff(test)
    // console.log(selectedTariff);
    // useForceUpdate()
    calculate()
  }
  const calculate =  () =>{
    var total = 0
    console.log(actions);
    if(actions.length>0){
      // console.log(actions);
    actions.map((item) => {
      total += Number(item.price)*Number(item.qty)
      console.log(total);
    })
    setTotalAmount(total)
    console.log(totalAmount);
  }
  else setTotalAmount(1)
  }

  const calculate2 =  (ttt) =>{
    var total = 0
    console.log(actions);
    if(ttt.length>0){
      // console.log(actions);
    ttt.map((item) => {
      total += Number(item.price)*Number(item.qty)
      console.log(total);
    })
    setTotalAmount(total)
    console.log(totalAmount);
  }
  else setTotalAmount(0)
  }


  const deleteItem = (title) =>{
    const test = []
    for (let i = 0; i < actions.length; i++) {
        if (actions[i].title !== title) {
            test.push(actions[i]);
        }
    }
    setActions(test)
    console.log(test)
    calculate2(test)

  }
  return (
      <Layout style={styles.container} >
        <View>
        <Layout>
          <TopBar title='استعلام قیمت خدمات' />
        </Layout>
        <View style={{ marginVertical:10, alignItems:'center', justifyContent:'flex-start'}}>
          <Text>موارد مورد نظر جهت استعلام را از لیست انتخاب نمایید:</Text>
          <AutocompleteSimpleUsageShowcase model={''} flatListProps={{height:500}}  setSelect={setSelectedTariff}/>
        {/*<Select
          style={{flex:1, margin:10}}
          label={evaProps => <Text {...evaProps}>قطعه یا سرویس</Text>}
          selectedIndex={serviceSelectedIndex}
          value = {services[serviceSelectedIndex.row]?services[serviceSelectedIndex.row]['service_name'] : null}
          onSelect={index => setServiceSelectedIndex(index)}>
          {
            services.map((data)=>{
                return <SelectItem title={data.service_name}/>
            })
          }
        </Select>*/}
          <Input keyboardType='numeric' style={{margin:10, width: 0.62*width}} value={qty} label='تعداد' onChangeText = {newValue =>{ setQty(newValue)}}/>
          <View style={{alignItems:'center', flexDirection:'row', justifyContent:'flex-end', marginBottom:15}}>
            <Text category='c1'>قیمت واحد: </Text>
          {/*  <Text category='h6' status='primary'>{services[serviceSelectedIndex.row]?services[serviceSelectedIndex.row]['service_cost'] : 0}</Text>
            */}
            <Text category='h6' status='primary'>{selectedTariff ? selectedTariff.service_cost : 0}</Text>
            <Text category='c1'> ریال</Text>
          </View>
          <View style={{flexDirection:'row'}}>
          <Button style={{marginHorizontal: 10}} appearance='outline' size='small' onPress={()=>{RootNavigation.navigate('invoice')}}>
            بازگشت
          </Button>
          <Button style={{marginHorizontal: 10}} appearance='outline' size='small' onPress={() => {setActions([]);calculate(); setTotalAmount(0)}}>
            پاک کردن
          </Button>
          <Button disabled={!selectedTariff} style={{marginHorizontal: 10}} size='small' onPress={() => clickAdd()}>
            افزودن
          </Button>
          </View>
        </View>
        <ScrollView>
        {
          actions.map((data, index) => {
            return(
              <TouchableOpacity
                onLongPress={()=>{deleteItem(data.title)}}
                style={{flexDirection:'row', justifyContent: 'space-between',  width: width-20, marginBottom:5}}>
              <View style={{width: width*0.65, marginHorizontal:10}}>
                <Text category='c1'>{index+1}- {data.title}</Text>
              </View>
              <View style={{width: width*0.1}}>
                <Text category='c1'>  x  {data.qty}</Text>
              </View>
              <View style={{width: width*0.25}}>
                <Text category='c1'>{Number(data.price)/* * Number(data.qty)*/} ریال</Text>
              </View>
              </TouchableOpacity>
            )
          })
        }
        <View style={{alignItems:'center', flexDirection:'row', justifyContent:'flex-end', marginBottom:15, marginHorizontal: 25}}>
          <Text category='c1'>مجموع هزینه: </Text>
        {/*  <Text category='h6' status='primary'>{services[serviceSelectedIndex.row]?services[serviceSelectedIndex.row]['service_cost'] : 0}</Text>
          */}
          <Text category='h6' status='primary'>{totalAmount}</Text>
          <Text category='c1'> ریال</Text>
        </View>
        </ScrollView>

        </View>
        <View>

        </View>
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between',
    height: height


  },
});
